import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const WaterDrop = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M20 4C20.3678 4 20.706 4.20193 20.8804 4.52577L29.8132 21.1094C33.5518 28.0502 28.0516 36 20 36C11.9484 36 6.44818 28.0502 10.1869 21.1094L19.1196 4.52577C19.294 4.20193 19.6322 4 20 4ZM20 7.10869L11.9477 22.0578C9.04589 27.4449 13.2031 34 20 34C26.7969 34 30.9541 27.4449 28.0524 22.0578L20 7.10869ZM15 24C15.5523 24 16 24.4477 16 25C16 26.0529 16.0189 27.0517 16.3944 27.8028C16.565 28.144 16.8067 28.4222 17.1731 28.6258C17.5502 28.8353 18.122 29 19 29C19.5523 29 20 29.4477 20 30C20 30.5523 19.5523 31 19 31C17.878 31 16.9498 30.7897 16.2019 30.3742C15.4433 29.9528 14.935 29.356 14.6056 28.6972C13.9987 27.4834 13.9995 26.0312 14 25.081C14 25.0536 14 25.0266 14 25C14 24.4477 14.4477 24 15 24Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default WaterDrop;
